import variableColors from "@/base/global/variables/figma.colors.json";
import variableTypography from "@/base/global/variables/figma.typography.json";

export const switchThemeToken: any = {
  //=============================== SIZE ===============================//
  trackHeight: 20,
  trackHeightSM: 16,
  trackMinWidth: 36,
  trackMinWidthSM: 36,
  innerMaxMargin: 22,
  innerMaxMarginSM: 18,
  handleSize: 16,
  handleSizeSM: 12,

  //=============================== COLOR ===============================//
  colorTextQuaternary: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorTextTertiary: variableColors["ColorFigmaNeutralGrayscaleGray70"],
  colorPrimaryHover: variableColors["ColorFigmaComplementaryBlue50"],
  colorPrimary: variableColors["ColorFigmaComplementaryBlue50"],
  colorDisabledPrimary: variableColors["ColorFigmaComplementaryBlue30"],
  colorDisabled: variableColors["ColorFigmaNeutralGrayscaleGray30"],
  colorHandlerDisabled:
    variableColors["ColorFigmaNeutralGrayscaleGray60Disabled"],

  //========================= FONT =================================/
  fontFamily: variableTypography["BodyMediumFontFamily"],
  fontSize: variableTypography["BodyMediumFontSize"],
  fontSizeIcon: variableTypography["BodyMediumFontSize"],
  lineHeight: variableTypography["BodyMediumLineHeight"],
  lineHeightLG: variableTypography["BodyMediumLineHeight"],
};
